import { useKeycloakStore } from 'hooks/zustandStore';
import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import LegacyLoginPersonalDetails from './LegacyLoginPersonalDetails';
import PersonalDetails from './PersonalDetails';

export const PersonalDetailsResolver = () => {
  const isLegacyLogin = useKeycloakStore((state) => state.isLegacyLogin);
  const isLegacyLoginLoading = useKeycloakStore(
    (state) => state.isLegacyLoginLoading,
  );
  if (isLegacyLoginLoading || isLegacyLogin === null) {
    return <LoadingScreen />;
  }
  return isLegacyLogin ? <LegacyLoginPersonalDetails /> : <PersonalDetails />;
};
